






























// @ts-nocheck
import Vue from 'vue';
import { DetailStore, CfgStore } from '@/store/index';
import ProjectDesc from '@/components/ProjectDesc.vue';
import charity from '@/business/charity';
import { biHottag, url, windowHelper } from '@tencent/ppd-base-libs';
import { hideLoading } from '@/fit-components/loading/main';
import { isTencentCharity } from '@/business/helper';
import sdk from '@/business/sdk';
import BannerSwiper from '@/components/BannerSwiper.vue';
import TencentCharityTips from '@/components/TencentCharityTips.vue';
import GongyiDetail from '@/components/GongyiDetail.vue';
import { getProjectById, getOrganByOid, getOrderProjectList } from '@/business/cfg';
import { FitNavTabs } from '@tencent/wphk-ui';
import PageTab from '@/components/page-tab.vue';
import { BaseComponent } from '@tencent/wphk-components-content-loader';
import ContentLoader from '@/components/content-loader.vue';

let pid = url.getUrlParam('pid');
const tencentCharity = isTencentCharity();

if (pid === '22') {
  pid = '39';
}

export default Vue.extend({
  name: 'home',
  data() {
    return {
      isReady: false,
      pageData: CfgStore,
      DetailStore,
      loading: true,
      tencentCharity,
      initFlag: false,
      activeTabId: '', // 当前活跃的tab
      randomProjectList: [], // 进入页面后随机出来的项目列表
    };
  },
  computed: {
    projectListInTab() {
      return this.randomProjectList.filter(p => p.tabIds.includes(this.activeTabId));
    },
    bannerConfigList() {
      return this.pageData.bannerCfg;
    },
    tabList() {
      return this.pageData.tabCfg.map(tab => {
        const { tabName, tabId } = tab;
        return {
          name: tabName,
          id: tabId,
        };
      });
    },
  },
  watch: {
    initFlag(newVal) {
      if (newVal) {
        this.shareInit();
      }
    },
  },
  methods: {
    handleTabChange({ id }) {
      this.activeTabId = id;
    },
    getOrganByOid,
    goDeedDay() {
      biHottag('wallet.charity.home.deedbanner_click');
      windowHelper.redirect(
        'https://prom.wechatpay.com.hk/good-deed-day/index.shtml?ADTAG=charity',
        300,
      );
    },
    showTencentTips() {
      biHottag('wallet.charity.home.redbanner_click');
      DetailStore.tencentCharityTipsShow = true;
    },
    handleClickProject(item) {
      Object.assign(DetailStore, item);
      this.$router.push({ path: 'detail' });
      sessionStorage.setItem('pid', item.pid);
      sessionStorage.setItem('oid', item.oid);
      biHottag('wallet.charity.home.project_click', {
        fcharity_project: item.pid,
        fcharity_organization: item.oid,
      });
    },
    goRecord() {
      this.$router.push({ path: 'record' });
      biHottag('wallet.charity.home.history_click');
    },
    shareInit() {
      sdk.share({
        url: 'https://apps.wechatpay.com.hk/charity/index.shtml?ADTAG=share',
        desc: tencentCharity
          ? '99公益日正在進行中，你捐HK$1，騰訊基金會捐多HK$1!'
          : '伸出援手，匯聚愛心，幫助更多有需要的人',
        title: tencentCharity ? '香港99公益日' : 'WeChat Pay HK 慈善平台',
        imgUrl: tencentCharity
          ? 'https://st.moneydata.hk/res/fmd_mojo_static/0ZA1aCIRgRo9YzgB1piHSXyGyj9Oopyp.png'
          : 'https://st.moneydata.hk/res/fmd_mojo_static/MnU8oCJODOUZXNjxf6fmaRoLCMiwNaqK.png',
      });
    },
  },
  components: {
    ProjectDesc,
    BannerSwiper,
    TencentCharityTips,
    GongyiDetail,
    FitNavTabs,
    PageTab,
    BaseComponent,
    ContentLoader,
  },
  async created() {
    setTimeout(() => {
      this.isReady = true;
    }, 4000);
    const { pageData: data } = await charity.getHomepageInit();
    this.isReady = true;
    let clickItem;
    data.product_list.forEach((item) => {
      const project = getProjectById(item.product_id);
      if (project) {
        project.totalCount = item.total_count;
        if (pid === item.product_id) {
          clickItem = project;
        }
      }
    });

    this.activeTabId = this.pageData.tabCfg[0].tabId;
    // 筛选符合资格的列表
    const arr = this.pageData.projectData.filter(project => (project.isOnline && project.isDisplayOnIndex));
    // 固定的随机列表
    this.randomProjectList = getOrderProjectList(arr);

    this.initFlag = true;

    this.$nextTick(function () {
      hideLoading();
      this.loading = false;
      if (pid && clickItem) {
        this.handleClickProject(clickItem);
      }
    });
  },
  activated() {
    biHottag('wallet.charity.home.index_view');
    if (this.initFlag) {
      this.shareInit();
    }
  },
});
